// extracted by mini-css-extract-plugin
export var measureBox = "_81-0";